'use strict';

// Dynamically load reCAPTCHA script
function loadReCaptcha(siteKey) {
  return new Promise((resolve, reject) => {
    if (!window.grecaptcha) {
      const script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js?render=' + siteKey;
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Failed to load reCAPTCHA'));
      document.body.appendChild(script);
    } else {
      resolve(); // Script already loaded
    }
  });
}

module.exports = {
  loadReCaptcha: loadReCaptcha
}